import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import MachineList from '../components/MachineList'
import AppModel from '../DataModel/AppModel';
import { Link } from 'react-router';
import CircularProgress from 'material-ui/CircularProgress';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Add from 'material-ui/svg-icons/content/add';
import PageLoading from '../components/PageLoading';
import right_corner_style from '../utils/right-corner-style';

export default
@observer class MachinesPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  gotoNewMachinePage() {
    this.context.router.push('/machine_admin/newMachine');
  }

  render() {
    return (
      <PageLoading loading={AppModel.fetchingMachineList}>
        <MachineList  appState={AppModel} />
        {AppModel.canRegisterMachines?
          <FloatingActionButton style={right_corner_style}
                              children={<Add />}
                              onTouchTap={this.gotoNewMachinePage.bind(this)} />
          :null
        }

      </PageLoading>

    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/MachinesPage.jsx
 **/